import type {FC} from "react"

import {BackButton} from "components/button"

import {UserHeader, UserHeaderProps} from "./UserHeader"

interface Props extends UserHeaderProps {
  href?: string
}

export const UserHeaderWithBackButton: FC<Props> = ({href, ...props}) => (
  <UserHeader {...props}>
    <BackButton {...{href}} className="py-0" />
  </UserHeader>
)
